import { Box } from "@mui/material"
import { COLORS } from "shared/constants/AppEnums"
import PropTypes from 'prop-types'

const Bullet = ({ bgColor }) => {
    return (
        <Box sx={{
            backgroundColor: bgColor ? bgColor : COLORS.primary,
            minWidth: '10px !important',
            minHeight: '10px !important',
            borderRadius: '100%',
            // marginTop: 0.5
        }}>

        </Box>
    )
}

Bullet.propTypes = {
    bgColor: PropTypes.any
}

export default Bullet